import { CREHANA_BASE_URL_PRD, CREHANA_HOSTNAME_PRD } from '@crehana/constants';

import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

import {
  BASE_URL,
  MEMBERSHIP_POLICY_DUO_ROUTE,
  MEMBERSHIP_POLICY_FAMILY_ROUTE,
  MEMBERSHIP_POLICY_PREMIUM_ROUTE,
  MEMBERSHIP_POLICY_ROUTE_PATH,
  MEMBERSHIP_POLICY_STUDENT_ROUTE,
  PAYG_POLICY_ROUTE_PATH,
  PRIVACY_PE_ROUTE,
  PRIVACY_ROUTE_PATH,
} from '../constants';
import HPBackToSchoolCampaign from './HPBackToSchoolCampaign';

const TermsAndConditions = () => (
  <RouteWrapper>
    <section>
      <Subtitle>1. Introducción</Subtitle>
      <p>
        El presente documento establece los términos y condiciones generales del
        uso (“
        <strong>Términos y Condiciones Generales</strong>
        ”) que serán aplicables cuando usted visite y/o utilice la Plataforma
        Digital y/o el Sitio Web <Link href={`${CREHANA_BASE_URL_PRD}/`} /> (en
        adelante, de manera conjunta “<strong>Plataforma</strong>”), cuyas
        titularidades y contenido son de total autoría de CREHANA EDUCATION,
        INC. (<strong>“CREHANA”</strong>), sociedad constituida en Delaware,
        Estados Unidos de América, con Registro de Contribuyente 36-4888645,
        domiciliada en 929 SW 122ND, AVE, MIAMI FL 33184-2477.
      </p>
      <p>
        A continuación, se muestra la información legal aplicable a CREHANA y
        sus subsidiarias en Perú: CREHANA EDUCATION PERÚ S.A.C., en Colombia:
        CREHANA EDUCATION COLOMBIA S.A.S. y México CREHANA EDUCATION MÉXICO S.
        DE R.L. DE C.V. Para mayor detalle pueden desplegar los avisos
        correspondientes a cada país en esta sección, al lado izquierdo de la
        pantalla.
      </p>
      <p>
        Es necesario también leer las Políticas de Privacidad, en donde
        detallamos nuestras prácticas de manejo de información{' '}
        <Link
          href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${PRIVACY_ROUTE_PATH}${PRIVACY_PE_ROUTE.path}`}
          navLink={`${PRIVACY_ROUTE_PATH}${PRIVACY_PE_ROUTE.path}`}
        />
        . Nos preocupamos por mantener seguros a nuestros usuarios y estamos en
        constante trabajo para recopilar la información de manera confidencial.
        El acceso y/o utilización del Sitio Web atribuye al internauta la
        condición de usuario del Sitio Web (el “<strong>Usuario</strong>” o los
        “<strong>Usuarios</strong>”), lo cual implica la plena aceptación de
        todas las disposiciones incluidas en el presente documento.
      </p>
    </section>
    <section>
      <Subtitle>2. Definiciones</Subtitle>
      <p>
        Sin perjuicio de los términos definidos en diversas secciones del
        presente documento, los términos aquí utilizados con la primera letra
        mayúscula y que no sean definidos de forma diversa, tendrán el
        significado que a continuación se les atribuye, pudiendo ser utilizados
        en masculino, femenino o neutro, así como en singular o en plural,
        indistintamente y según el contexto:
      </p>
      <ul>
        <li>
          “<strong>Cookie</strong>” es el archivo de datos que se almacena en el
          dispositivo del Usuario cuando éste tiene acceso al Sitio.
        </li>
        <li>
          “<strong>Cuenta del Usuario</strong>” es la forma de identificación
          creada (que consta de un ID de acceso y contraseña) que se le da a los
          Usuarios para que puedan acceder a los Servicios que ofrece CREHANA a
          través de la Plataforma. (En adelante, la “<strong>Cuenta</strong>” o
          “<strong>Cuenta del Usuario</strong>”).
        </li>
        <li>
          “<strong>Curso</strong>” es aquel espacio curricular en el cual los
          Mentores y/o Profesores se encargarán de impartir conocimientos
          respecto de una determinada materia y/o tema en particular a un número
          de Usuarios 1 mediante clases dictadas a través de la Plataforma de
          CREHANA.
        </li>
        <li>
          “<strong>Leyes Vigentes</strong>” significan todas las leyes, códigos,
          normas jurídicas, ordenanzas, reglamentos, tratados, reglas, normas,
          permisos, resoluciones, órdenes, interpretaciones, decisiones,
          interdictos, así como las normas, resoluciones y sentencias que
          actualmente o en el futuro estén vigentes en Perú y resulten
          aplicables a los Usuarios.
        </li>
        <li>
          “<strong>Membresías</strong>” es el término con el que se define a los
          tipos de suscripción por un tiempo limitado a nuestros Servicios, los
          cuales otorgan opciones de accesos a los Cursos y Servicios que ofrece
          Crehana a través de la Plataforma, a fin de que el Usuario pueda
          elegir la opción más conveniente dependiendo de sus preferencias,
          tarifas, y Cursos.
        </li>
        <li>
          “<strong>Mentores</strong>” es aquella persona especializada en
          determinadas disciplinas, materias, entre otros integradas
          relacionados a los Cursos, que compartirán su experiencia y
          conocimientos con los Usuarios, a fin de poder guiarlos o absolver las
          dudas que los Usuarios tengan en los Cursos.
        </li>
        <li>
          “<strong>Plataforma</strong>” se refiere al sitio web, plataforma
          virtual, y otros medios digitales como aplicaciones para dispositivos
          smartphones con tecnología IOS o Android, tablets, SmartTv, entre
          otros, cuyas titularidades corresponden a CREHANA, y que dentro de los
          cuales los Usuarios se registran para obtener el Servicio.
        </li>
        <li>
          “<strong>Producto</strong>” es el término que define el acceso al
          Curso o a un pack de Cursos, dentro del catálogo de Cursos ofrecido
          por CREHANA, independientemente a la suscripción de una Membresía. En
          caso el Usuario elija acceder a uno de los Productos, este podrá
          acceder al Curso y visualización de clases virtuales grabadas y sus
          respectivos contenidos.
        </li>
        <li>
          “<strong>Profesor</strong>” es aquel profesional o especialista en una
          determinada materia o ámbito de conocimiento, disciplina académica,
          ciencia o arte que, enseñará un Curso o varios Cursos de manera
          virtual, a través de la Plataforma.
        </li>
        <li>
          “<strong>Servicio</strong>” es el servicio brindado por CREHANA el
          cual consiste en poner a disposición de sus Usuarios, Cursos sobre
          diversas temáticas o ámbitos de conocimiento, disciplina académica,
          ciencia o arte, los cuales son dictados por Profesores y/o Mentores
          especializados en la materia. El servicio brindado a través de la
          Plataforma podrá estar conformado de Cursos en línea y/o en vivo,
          ayuda personalizada en los Cursos a través de Mentores, eventos y
          video conferencias, entre otros, que CREHANA comunique en su debido
          momento.
        </li>
        <li>
          “<strong>Usuario</strong>” es aquella persona natural que se registra
          en la Plataforma con la finalidad de contratar el Servicio y/o los
          Servicios expuestos por CREHANA. Asimismo, podrán ser Usuarios de la
          Plataforma aquellas partes interesadas en formar parte de la
          experiencia brindada a través de nuestros Servicios tales como los
          Profesores, afiliados y miembros del equipo de CREHANA.
        </li>
        <li>
          “<strong>Tarifa</strong>” es el precio que el Usuario deberá pagar
          para acceder a alguna de las Membresías que ofrece CREHANA. La tarifa
          podrá ser pagada a través de los medios de pago que pone a su
          disposición CREHANA en la Plataforma.
        </li>
        <li>
          “<strong>Términos y Condiciones particulares</strong>” serán los
          términos y condiciones propios de cada membresía.
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>3. Descripción del Sitio</Subtitle>
      <p>
        La Plataforma es una comunidad educativa para personas que quieren
        aprender habilidades creativas de profesionales en el mercado. Dentro de
        CREHANA, los Usuarios podrán inscribirse a Cursos online, compartir
        proyectos personales, contribuir y aprender en foros de discusión,
        interactuar con personas que guarden mismos intereses y leer o comentar
        en artículos o tutoriales. En la Plataforma también podrán publicar
        imágenes, fotografías, archivos de audio y video, compartir promociones,
        descuentos, si así lo desean y previa autorización por parte del
        Usuario.
      </p>
      <p>
        A través de la Plataforma, los Usuarios se inscriben a Cursos, a través
        de los cuales pueden tener acceso a contenido audiovisual, foros de
        discusión y contacto directo con el Profesor de la clase. Estas
        Condiciones, las Políticas de Privacidad y otros avisos legales
        publicados por CREHANA son ajenos a los acuerdos, comunicados y otros
        documentos (“<strong>Compromisos de Clase</strong>”) que el alumno y
        Profesor puedan fijar dentro de la clase. CREHANA no se hará responsable
        por ninguna obligación incluida dentro de los Compromisos de Clase o por
        cualquier acción tomada en base a los mismos, además de no considerarse
        parte de ninguna de las transacciones entre el alumno y el Profesor.
        CREHANA se reserva el derecho de eliminar la oferta de cualquier clase
        y/o Curso, en cualquier momento y por cualquier motivo.
      </p>
    </section>
    <section>
      <Subtitle>4. Aceptación de las condiciones</Subtitle>
      <p>
        CREHANA ha puesto a su disposición la Plataforma, por lo que, al acceder
        a ella, usted debe de leer, comprender y aceptar estos términos y
        condiciones (las “<strong>Condiciones</strong>”) Asimismo, queda sujeto
        a estas Condiciones que, junto con nuestras Políticas de Privacidad,
        rigen nuestra relación con usted dentro de la Plataforma. Solo podrá
        registrarse y ser Usuario de la Plataforma, después de haber aceptado
        las Condiciones, en caso de no aceptarlos, se le solicita que no haga
        uso, ni acceda, ni manipule la información de los Servicios ofrecidos
        por la Plataforma, ya que usted estaría haciendo un uso inadecuado de
        ésta.
      </p>
    </section>
    <section>
      <Subtitle>5. Disponibilidad de los Contenidos</Subtitle>
      <p>
        Los contenidos mostrados a través de la Plataforma podrán incluir todo
        tipo de archivos, que podrán ser propios o de terceros, tales como
        textos, imágenes, sonidos y videos, enlaces (links) a otros sitios o
        aplicaciones ajenos a CREHANA, y cualquier otro contenido que CREHANA
        considere pertinente agregar.
      </p>
      <p>
        CREHANA no garantiza que los contenidos que se ofrecen en la Plataforma
        estén disponibles siempre, por lo que CREHANA se reserva el derecho de
        suspender o adicionar cualquier funcionalidad en la Plataforma.
      </p>
    </section>
    <section>
      <Subtitle>6. Acceso y utilización del Sitio Web</Subtitle>
      <p>
        Los Usuarios podrán disfrutar de todas las funcionalidades y Servicios
        que ofrece la Plataforma, desde que se registran en la Cuenta y opten
        por alguna de las Membresías, salvo CREHANA haya lanzado algún plan
        gratuito al momento del registro.
      </p>
      <p>
        El acceso y el uso de la Plataforma sólo podrá ser realizado por
        aquellas personas que conforme a la legislación aplicable tengan
        capacidad de ejercicio plena para celebrar actos jurídicos. En caso que,
        algún menor de edad, quiera acceder a los Servicios que ofrezca la
        Plataforma, los que ejerzan la patria potestad o tutores de los menores
        de edad o de aquellas personas reputadas por las Leyes Vigentes como
        sujetos de derecho con incapacidad absoluta serán responsables por los
        actos realizados por estos últimos.
      </p>
    </section>
    <section>
      <Subtitle>7. Registro</Subtitle>
      <p>
        Los Usuarios deberán registrarse en la Plataforma para crearse una
        Cuenta, debiendo completar el formulario de registro con toda su
        información personal tales como nombres completos, un nombre de usuario,
        colocar un correo electrónico, entre otros. Asimismo, deberá elegir una
        contraseña.
      </p>
      <p>
        Solo se podrá registrar una cuenta por Usuario. El Usuario deberá de
        proporcionar información certera, completa y actualizada. No hacerlo
        representa una violación de los presentes Términos y Condiciones
        Generales y podría significar la cancelación de la cuenta, si en caso
        CREHANA lo considere conveniente.
      </p>
      <p>
        El nombre de Usuario elegido al momento del registro no deberá atentar
        contra las buenas costumbres, vulnerar los derechos de terceros,
        provocar equívocos, confundir a otros usuarios ni atentar contra la
        reputación o imagen de CREHANA, reservándose el derecho de modificar
        cualquier nombre de usuario que considere inapropiado sin previo aviso.
      </p>
    </section>
    <section>
      <Subtitle>8. Responsabilidad por contraseñas</Subtitle>
      <p>
        Es responsabilidad del Usuario cuidar sus datos de ingreso y de
        cualquier actividad dentro de su cuenta, por lo que deberá mantenerla
        bajo absoluta reserva y confidencialidad, quedando prohibida la acción
        de compartirla con terceros. Toda acción realizada a través de la Cuenta
        del Usuario se presume realizada por este y no se admite prueba en
        contrario.
      </p>
      <p>
        CREHANA no se hace responsable de los daños y perjuicios que puedan
        suceder por actos de seguridad ni de los daños relacionados con la
        divulgación del nombre del Usuario o de su contraseña. Si existe algún
        tipo de violación de seguridad o identifica que alguien ha accedido a su
        cuenta, el Usuario debe de notificarlo instantáneamente a CREHANA.
      </p>
      <p>
        En caso de olvido de la contraseña o de cualquier otra circunstancia que
        suponga un riesgo de acceso y/o de utilización por parte de terceros no
        autorizados, el Usuario lo comunicará inmediatamente a CREHANA, a fin de
        proceder inmediatamente con el bloqueo y/o sustitución de la misma. En
        todo caso, todas las operaciones o transacciones realizadas con
        anterioridad a dicha comunicación se entenderán efectuadas por el
        Usuario, quien, de ser el caso, será responsable y pagará los gastos y
        los daños y perjuicios que se deriven de cualquier acceso o uso no
        autorizado a la Plataforma.
      </p>
    </section>
    <section>
      <Subtitle>9. Uso correcto de la Plataforma</Subtitle>
      <p>
        La Plataforma podrá ser utilizada únicamente con fines lícitos y que no
        transgredan las buenas costumbres y/o el presente documento.
      </p>
      <p>
        El Usuario se compromete a utilizar la Plataforma con fines lícitos y
        que no transgredan el ordenamiento jurídico, el orden público y las
        buenas costumbres. En ese sentido, a título meramente enunciativo, pero
        no limitativo, el Usuario se abstendrá, entre otros, de:
      </p>
      <ol>
        <li>
          Abusar, acosar, amenazar, suplantar o intimidar a cualquier persona.
        </li>
        <li>
          Publicar o transmitir cualquier tipo de contenido difamatorio,
          obsceno, pornográfico, abusivo, ofensivo, profano o que infrinja
          derecho de autor o derechos en general de cualquier persona.
        </li>
        <li>
          Intentar acceder o realizar búsquedas en motores de búsquedas o
          softwares (spiders, robots, crawlers, herramientas de minería de datos
          o similares) distintos de aquellos provistos por CREHANA o aquellos
          motores de búsquedas genéricos provistos por terceros y de acceso
          público la Internet.
        </li>
        <li>Generar o enviar correos no deseados a cualquier persona o URL.</li>
        <li>
          Crear cuentas múltiples con el objetivo de votar a favor o en contra
          de los proyectos de otros usuarios.
        </li>
        <li>
          Publicar contenidos de los cuales no posea los derechos de autor.
        </li>
        <li>
          Aumentar o alterar el número de votos o comentarios de forma
          artificial, o bien de otro Servicio, con el fin de dar o recibir
          dinero o cualquier tipo de compensación por dichos votos.
        </li>
        <li>Vender o transferir su Cuenta de Usuario.</li>
        <li>
          Utilizar la Plataforma para fines comerciales o para el beneficio de
          terceros de manera que infrinja lo establecido en el presente
          documento.
        </li>
        <li>
          Manipular cualquier paquete TCP/IP, encabezado (header) o cualquier
          parte de la información de encabezado en cualquier correo electrónico,
          newsgroup, newsletter o utilizar de cualquier manera la Plataforma
          para enviar información falsa, alterada o que no permita identificar
          la fuente original desde donde se envió.
        </li>
        <li>
          Intentar descifrar, descompilar o aplicar ingeniería en reversa a
          cualquier programa de software proveedor del Sitio Web, entre otros.
        </li>
      </ol>
      <p>
        Asimismo, CREHANA ha establecido los siguientes lineamientos generales
        para el correcto uso de los Servicios y Membresías, por lo que el
        Usuario deberá acatarlas y alentar a otros los Usuarios a hacer lo
        mismo:
      </p>
      <ul>
        <li>
          El Usuario podrá hacer uso de los Servicios de CREHANA, bajo
          conformidad con las Leyes Vigentes.
        </li>
        <li>
          El Usuario podrá acceder de manera ilimitada a la Plataforma y
          descargar los contenidos dentro del plazo de vigencia de la Membresía
          elegida.
        </li>
        <li>
          El Usuario no podrá descargar, grabar, archivar, reproducir,
          distribuir, modificar, mostrar, ejecutar, publicar, otorgar licencias,
          crear obras derivadas basadas en el contenido de titularidad de
          CREHANA u obtenida a través de su Plataforma, con fines lucrativos.
        </li>
        <li>
          El Usuario dependiendo de la Membresía que elija tendrá permitido
          guardar el acceso a su Cuenta en más de un dispositivo (smartphones,
          tablets, SmartTv). Sin embargo, no podrá acceder a su Cuenta de manera
          simultánea en más de un dispositivo.
        </li>
        <li>
          El Usuario podrá compartir contenidos de manera pública en la
          Plataforma, por lo que, no deberá realizar acciones, comentarios o
          compartir archivos que demuestren acoso, referencias sexuales, abuso,
          bullying, racismo, spam, u otra acción que atente contra las normas y
          las buenas costumbres, o que afecten a la comunidad de CREHANA.
        </li>
      </ul>
      <p>
        CREHANA se reserva el derecho de retirar, terminar o suspender, sin
        previo aviso y en cualquier momento la Cuenta a aquellos Usuarios que
        infrinjan los presentes Términos y Condiciones Generales, por lo que,
        por favor, le pedimos que no use CREHANA para ningún fin ilícito y/o
        negativo.
      </p>
    </section>
    <section>
      <Subtitle>10. Contenido compartido en el Sitio Web</Subtitle>
      <p>
        El Usuario conservará todos los derechos y propiedad intelectual del
        contenido que comparta en CREHANA. Sin embargo, al subir o compartir
        cualquier tipo de contenido a la Plataforma, le concede a CREHANA (y
        afiliados o socios comerciales y de comunicación) una licencia global,
        no exclusiva, para comunicar, distribuir, alojar, modificar o derivar
        trabajos, presentar, publicar, reproducir, almacenar o utilizar el
        contenido. Si incluimos el contenido compartido a través de cualquier
        medio de comunicación de CREHANA, le daremos todos los créditos
        merecedores.
      </p>
      <p>
        Además, al compartir el contenido, le concede a CREHANA y a sus Usuarios
        y visitantes el derecho de compartirlo a través de varias plataformas de
        redes sociales integradas a la Plataforma (Facebook, Twitter, Pinterest,
        Instagram o Linkedin). CREHANA no asegura ni garantiza que el contenido
        que se publique en la Plataforma no resulte copiado de forma ilegal y
        sin su consentimiento.
      </p>
      <p>
        CREHANA tampoco les prohíbe a los Usuarios y visitantes de la Plataforma
        que hagan copias en baja resolución o miniaturas de su trabajo, por lo
        que autoriza que CREHANA permita a los usuarios y visitantes de la
        Plataforma hacer dichas copias de su contenido en baja resolución.
      </p>
    </section>
    <section>
      <Subtitle>11. Productos y Membresías que ofrece la Plataforma</Subtitle>
      <p>CREHANA pone a disposición de sus Usuarios Productos y Membresías.</p>
      <p>
        A los Productos que CREHANA exponga a través de la Plataforma, se les
        denominará “<strong>Productos Pay as You Go</strong>”, os que podrán
        incluir Cursos y/o packs de Cursos, seleccionados conforme a sus
        necesidades e intereses. El Usuario podrá acceder a los Productos “Pay
        as you go” realizando un pago único a través de la Plataforma, y tendrá
        acceso a sus contenidos de manera ilimitada durante la existencia de la
        Plataforma. El acceso a dichos Productos será independiente a las
        Membresías que podría adquirir dentro de la Plataforma. Si desea mayor
        información sobre los términos y condiciones particulares de los
        Productos “Pay as you go”, deberá acceder al siguiente enlace:{' '}
        <Link
          href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${PAYG_POLICY_ROUTE_PATH}`}
          navLink={`${PAYG_POLICY_ROUTE_PATH}`}
        />
        .
      </p>
      <p>
        Por otro lado, los Usuarios podrán acceder a las siguientes Membresías:
        (i) Premium Individual, (ii) Premium Dúo, (iii) Premium Familiar, y (iv)
        Premium Estudiantil, a través de las cuales los Usuarios tendrán la
        opción de acceder a la variedad de Cursos que ofrece la Plataforma. Si
        deseas mayor información sobre los beneficios, condiciones y
        restricciones de cada una de las Membresías, podrás revisarlo en sus
        Términos y Condiciones Particulares correspondientes, ingresando a las
        siguientes direcciones URL:
      </p>
      <ul>
        <li>
          Premium Individual (
          <Link
            href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_PREMIUM_ROUTE.path}`}
            navLink={`${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_PREMIUM_ROUTE.path}`}
          />
          )
        </li>
        <li>
          Premium Dúo (
          <Link
            href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_DUO_ROUTE.path}`}
            navLink={`${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_DUO_ROUTE.path}`}
          />
          )
        </li>
        <li>
          Premium Familiar (
          <Link
            href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_FAMILY_ROUTE.path}`}
            navLink={`${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_FAMILY_ROUTE.path}`}
          />
          )
        </li>
        <li>
          Premium Estudiantil (
          <Link
            href={`${CREHANA_BASE_URL_PRD}${BASE_URL}${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_STUDENT_ROUTE.path}`}
            navLink={`${MEMBERSHIP_POLICY_ROUTE_PATH}${MEMBERSHIP_POLICY_STUDENT_ROUTE.path}`}
          />
          )
        </li>
      </ul>
      <p>
        CREHANA se reserva el derecho de retirar, modificar y/o agregar
        Membresías en la Plataforma, según lo considere conveniente. Asimismo,
        en caso, CREHANA modifique alguna de las Membresías será comunicado en
        los Términos y Condiciones Particulares de la Membresía y en la
        Plataforma, a fin de que el Usuario tome conocimiento de las nuevas
        condiciones.
      </p>
    </section>
    <section>
      <Subtitle>12. Cursos y especializaciones</Subtitle>
      <p>
        CREHANA mantiene sus Cursos y Especializaciones a la vanguardia y
        deseamos que nuestros Usuarios tengan una experiencia completa a través
        de la Plataforma. En ese sentido, CREHANA podrá otorgar diplomas a los
        Usuarios, dependiendo de la Membresía adquirida, y siempre y cuando haya
        finalizado el Curso o el conjunto de Cursos de una Especialización de
        manera satisfactoria.
      </p>
      <p>
        Los Cursos estarán integrados por un determinado número de clases
        virtuales grabadas, así como de ayuda personalizada en los Cursos a
        través de mentores, eventos y video conferencias, entre otros que
        CREHANA comunique en su debido momento. En ese sentido, el Usuario
        deberá asistir a un mínimo de clases por Curso.
      </p>
      <p>
        Por otro lado, la evaluación del desenvolvimiento y aprendizaje de los
        Usuarios estará a cargo de los Profesores del Curso y/o de los Mentores,
        por lo que, éstos asignarán a cada Usuario inscrito, la elaboración de
        un proyecto que desarrolle los contenidos del Curso, a fin de que el
        Usuario obtenga el diploma correspondiente. Cabe mencionar que, CREHANA
        se reserva el derecho de publicar en su Plataforma los mencionados
        proyectos, según su calificación y criterio. Al estar disponibles en la
        Plataforma podrán ser sometidos a votación y comentarios de los
        Usuarios, independientemente del Curso y/o Especialización.
      </p>
    </section>
    <section>
      <Subtitle>13. Tarifas</Subtitle>
      <p>
        Las tarifas de las Membresías se encontrarán reguladas en los Términos y
        Condiciones Particulares correspondientes a cada una. CREHANA se reserva
        el derecho de cambiar sus tarifas o cargos por los Servicios ofrecidos
        en la Plataforma (o de comenzar a cobrar por cualquier Servicio
        gratuito, previo aviso), tomando en cuenta que las Tarifas pagadas
        anteriores a dichas modificaciones no resultarán afectadas.
      </p>
      <p>
        CREHANA podrá modificar las Membresías y/o sus Tarifas si lo considera
        pertinente. Sin embargo, cualquier modificación en las Tarifas o en sus
        Membresías serán modificadas en los Términos y Condiciones Particulares
        correspondientes y serán notificadas al correo electrónico del Usuario
        y/o a través de la Plataforma.
      </p>
      <p>
        En la medida en que lo permita las Leyes Vigentes, los pagos no son
        reembolsables y no se otorgarán reembolsos ni créditos por los periodos
        de Membresía utilizados parcialmente o por el contenido de CREHANA no
        utilizado. No obstante, solo por motivos justificados, si el Usuario
        desea recibir un reembolso de la Tarifa pagada a CREHANA antes de que
        finalice el plazo su membresía deberá contactar con el siguiente correo
        electrónico <Link href="hola@crehana.com" />.
      </p>
    </section>
    <section>
      <Subtitle>14. Formas de Pago</Subtitle>
      <p>
        CREHANA se reserva el derecho de contratar a terceros que actúen como
        facilitadores para gestionar los pagos de las Tarifas que se realicen a
        través de la Plataforma. Asimismo, CREHANA procederá primero a verificar
        que el pago de la Tarifa haya sido debidamente efectuado para proceder
        con la activación de la Membresía.
      </p>
      <p>
        Las Membresías expuestas en la Plataforma, salvo que se señale lo
        contrario en casos particulares, podrán ser pagados a través de las
        siguientes modalidades (“<strong>Formas de Pago</strong>”):
      </p>
      <ul>
        <li>
          “<strong>Pago Diferido”</strong>: para lo cual el Usuario podrá
          efectuar el pago de la Tarifa a través de transferencias bancarias, ya
          sea por pay pal, pago en efectivo, u otras plataformas de pago que
          CREHANA habilite en la Plataforma.
        </li>
        <li>
          “<strong>Pago en línea</strong>”, para lo cual el Usuario podrá
          efectuar el pago de la Tarifa con tarjetas de crédito y/o débito a
          través de la pasarela de pagos de la Plataforma.
        </li>
      </ul>
      <p>
        El Usuario autoriza a CREHANA a hacer cargos a cualquier Forma de Pago
        asociada a su Cuenta. En ese sentido, en caso el Usuario, elija la
        modalidad de pago en línea, el pago de la Tarifa de la Membresía elegida
        será autorenovable, mientras que, si elige la modalidad de pago
        diferido, en caso, haya vencido el plazo de la membresía, el Usuario
        deberá reactivarla realizando el pago nuevamente. Tanto las Formas de
        Pago como las condiciones que la regulan podrán ser modificadas por
        CREHANA, si lo considera conveniente.
      </p>
      <p>
        Para algunas Formas de pago, el emisor puede cobrarle ciertos cargos,
        como cargos de transacción extranjera u otros cargos relacionados con el
        procesamiento de su Forma de pago. Asimismo, el Usuario se obliga a
        pagar todos los impuestos aplicables por su legislación, en caso los
        hubiere.
      </p>
      <p>
        El Usuario podrá actualizar su Forma de Pago a través de su Cuenta,
        siendo que luego de la actualización que se realice en su Cuenta,
        autoriza a CREHANA a hacer cargos a la Forma de Pago correspondiente.
      </p>
      <p>
        Si el pago no se pudiera efectuar satisfactoriamente, debido a la fecha
        de vencimiento, la falta de fondos u otros motivos, y si usted no
        cancela su cuenta, podemos suspender el acceso a los Cursos y/o
        Membresías hasta que obtengamos una Forma de pago válida.
      </p>
      <p>
        Para pagos realizados en Membresías y productos Pay As you Go, la última
        tarjeta que utilice el Usuario se quedará guardada como método de pago
        predeterminado. El Usuario podrá eliminar esta información cuando desee,
        ingresando a la configuración de tu cuenta, en la sección “Método de
        Pago”. De igual forma, el Usuario siempre puede elegir continuar con una
        compra directa o cambiar el método de pago en el check-out.
      </p>
      <p>
        Cuando se ofrezcan cuotas con o sin interés (también llamadas meses sin
        interés), las misma aplicarán sólo para los pagos con tarjetas de
        crédito y no con tarjetas de débito
      </p>
    </section>
    <section>
      <Subtitle>15. Renovación, cancelación y/o cambios de membresía</Subtitle>
      <ul>
        <li>
          <strong>Renovación</strong>. - Recuerda que todas nuestras Membresías
          son autorrenovables, por lo que si no deseas renovar deberás acceder
          al panel de configuración de Usuario (únicamente a través de la web y
          antes del vencimiento de la membresía), donde habrá una opción para
          cancelar la autorrenovación del Servicio:
          <Link href={`${CREHANA_BASE_URL_PRD}/configuracion/#/suscripcion`} />
        </li>
        <li>
          <strong>Cancelación</strong>. - El Usuario podrá cancelar su Membresía
          cuando lo considere conveniente. Si se cancela, perderá acceso a todos
          los Cursos a los cuales se haya inscrito (a menos que estas sean de
          acceso gratuito, comprados de manera individual o por packs
          previamente). Si decide pagar nuevamente recuperará el acceso a los
          Cursos inscritos.
        </li>
        <li>
          <strong>Cambios de Membresía</strong>. - El Usuario podrá cambiarse de
          Membresía si lo considera conveniente, de ser así, en caso, no haya
          finalizado el periodo de la misma, se generarán las siguientes
          consecuencias dependiendo de la nueva Membresía que el Usuario elija:
        </li>
        <ol>
          <li>
            Si elige una Membresía con una Tarifa menor: el Usuario deberá
            esperar que termine el plazo de su membresía para realizar el
            cambio.
          </li>
        </ol>
      </ul>
    </section>
    <section>
      <Subtitle>16. Sobre la relación con los Profesores</Subtitle>
      <p>
        CREHANA no mantiene una relación laboral ni de dependencia y/o
        subordinación con alguno de los Profesores. CREHANA únicamente es el
        productor del diseño de la temática de los Cursos y del contenido de la
        Plataforma, sin embargo, los Profesores tendrán libertad de cátedra, por
        lo que, CREHANA le otorga la confianza a sus profesores para exponer sus
        conocimientos e información sin sujetarse a una doctrina impuesta por
        CREHANA.
      </p>
      <p>
        El Profesor es un tercero que a través de clases expone un Curso y/o
        Cursos a través de la Plataforma, por lo que el Usuario reconoce que,
        CREHANA únicamente será responsable de validar que, el Profesor comparta
        el contenido adecuado y apropiado en los Cursos que enseñará a través de
        la Plataforma.
      </p>
      <p>
        En ese sentido, CREHANA no ofrece garantía alguna ni gestiona o
        interviene en la relación Profesor – Usuario, por lo que, en caso el
        Usuario tenga algún inconveniente con el contenido del Curso impartido
        por el Profesor o cualquier queja respecto del mismo, deberá comunicarlo
        a CREHANA, a través del siguiente correo electrónico{' '}
        <Link href="hola@crehana.com" />, a fin de que CREHANA pueda tomar las
        medidas pertinentes.
      </p>
      <p>
        En el supuesto de que, CREHANA detecte que el contenido compartido por
        el Profesor no cumpla con los estándares apropiados, CREHANA se
        encontrará facultado para restringir dicho contenido. Sin embargo,
        CREHANA no será responsable de la veracidad o exactitud de la
        información proporcionada por el Profesor a través del Curso.
      </p>
    </section>
    <section>
      <Subtitle>17. Sobre el contenido publicado por terceros</Subtitle>
      <p>
        CREHANA no controla ni se hace responsable por el acceso por parte de
        los Usuarios a contenidos, materiales, productos o servicios a través de
        enlaces de terceros colocados en el Sitio Web. El acceso a cualquier
        contenido incluyendo los enlaces mostrados en la Plataforma son
        opcionales, y correrán bajo su propio riesgo y cuenta, liberando a
        CREHANA de cualquier responsabilidad por dicha conducta.
      </p>
      <p>
        Por lo anterior y toda vez que, CREHANA no tiene control sobre los
        contenidos de sus proveedores y/o terceros, incluidos los sitios o
        aplicaciones a que lleven los enlaces, CREHANA no será responsable por
        los contenidos, materiales, acciones y/o servicios prestados por sus
        proveedores y/o terceros, ni por daños o pérdidas ocasionadas por la
        utilización de los mismos, sean causadas directa o indirectamente.
      </p>
    </section>
    <section>
      <Subtitle>18. Promociones, ofertas, lanzamientos comerciales</Subtitle>
      <p>
        En cualquier momento, CREHANA podrá lanzar ofertas promocionales, Cursos
        gratuitos, inclusive becas para alumnos nuevos, entre otros, por lo que,
        éstos se regirán bajo las condiciones y restricciones adicionales que se
        establezcan al momento de su lanzamiento, los cuales serán publicados en
        la página web de CREHANA.
      </p>
      <p>
        De la misma manera, a fin de que las Membresías de CREHANA se acomoden a
        las necesidades de sus Usuarios, por lo que, CREHANA podrá lanzar nuevas
        Membresías al mercado, las cuales se regirán por los Términos y
        Condiciones Particulares que se establezcan en dicho momento.
      </p>
    </section>
    <section>
      <Subtitle>19. Propiedad intelectual</Subtitle>
      <p>
        El software asociado a la Plataforma, así como todos los contenidos
        disponibles en el mismo, son propiedad exclusiva de CREHANA, y/o de ser
        el caso, de los Profesores, de sus proveedores o de sus servidores
        externos; por tanto, están protegidos por las leyes y los tratados
        internacionales en materia de derechos de autor, marcas, patentes,
        modelos y diseños industriales aplicables en la Perú, sin importar que
        se encuentren o no registrados.
      </p>
      <p>
        Se encuentra terminantemente prohibido cualquier tipo de copia,
        distribución, transmisión, retransmisión, publicación, impresión,
        difusión y/o explotación comercial del material y/o contenido puesto a
        disposición del público a través de la Plataforma, sin el previo
        consentimiento expreso y por escrito de CREHANA o, en su caso, del
        titular de los derechos de propiedad intelectual correspondientes. El
        incumplimiento de lo aquí mencionado sujetará al infractor a todos los
        reclamos civiles y será materia para la presentación de la querella, la
        denuncia o la reclamación procedente ante las autoridades competentes,
        dentro de la cual se proporcionará la información necesaria para la
        investigación y persecución del ilícito del que se trate.
      </p>
    </section>
    <section>
      <Subtitle>20. Derechos de Autor</Subtitle>
      <p>
        Todos los derechos de autor involucrados en la Plataforma, como por
        ejemplo su contenido y su diseño visual, son de titularidad de CREHANA
        y/o de sus proveedores, por lo que se encuentra estrictamente prohibido
        su empleo, modificación, reproducción, distribución, transmisión o
        comercialización de los derechos involucrados sin el permiso previo,
        expreso y por escrito de los titulares de dichos derechos, salvo los
        casos de derechos de cita, empleo para finalidades educativas y los
        demás usos honrados reconocidos.
      </p>
    </section>
    <section>
      <Subtitle>21. Privacidad</Subtitle>
      <p>
        De conformidad con la Ley de Protección de Datos Personales, aprobada
        por Ley No. 29733, CREHANA implementará todas las medidas posibles para
        mantener la confidencialidad y la seguridad de la información y datos de
        los Usuarios, pero no responderá por los daños, pérdidas o perjuicios
        que pudieran derivarse de la violación de esas medidas por parte de
        terceros que utilicen las redes públicas o internet, alterando los
        sistemas de seguridad para obtener acceso a la información de los
        Usuarios.
      </p>
      <p>
        Sin perjuicio de lo anterior, el uso de la Plataforma se encuentra
        condicionado a la lectura y aceptación libre por parte del Usuario de la
        Política de Privacidad, la cual se encuentra a su disposición en la
        Plataforma, por lo que, en caso de registrarse como Usuario en CREHANA,
        el Usuario manifiesta su conformidad con las Políticas de Privacidad.
      </p>
      <p>
        Crehana realiza alianzas con otras instituciones, razón por la cual en
        virtud de dichas alianzas y con las autorizaciones pertinentes, se
        reserva el derecho de volver a contactar a las personas que hayan
        participado como usuarios finales (beneficiarios) en alguna de estas
        alianzas.
      </p>
      <p>
        En caso de que te hayamos contactado de esta manera y no desees recibir
        nuestra información, puedes solicitarnos que te retiremos de nuestra
        base de datos a través de <Link href="hola@crehana.com" />.
      </p>
    </section>
    <section>
      <Subtitle>22. Cookies</Subtitle>
      <p>
        El Usuario conviene en recibir las Cookies que les transmitan los
        servidores de CREHANA. Las Cookies pueden contener información tal como
        la identificación proporcionada por el Usuario o información para
        rastrear las páginas que el Usuario ha visitado. Por ello, es importante
        que lea y acepte la Política de Cookies que se encuentra a disposición
        en la Plataforma, a fin de poder registrarse como Usuario y acceder a
        los Servicios.
      </p>
    </section>
    <section>
      <Subtitle>23. Exclusión de garantías</Subtitle>
      <ol>
        <li>
          <strong>Respecto de la información y contenidos</strong>. - CREHANA
          pone a disposición del Usuario un espacio virtual en el que podrá
          acceder a los Cursos dictados por los Profesores, por lo que, CREHANA
          no ofrece garantía alguna, ni gestiona o interviene en la relación, a
          los Servicios o información que puedan surgir entre los Usuarios.
        </li>
        <li>
          <strong>Respecto de errores o virus en la Plataforma</strong>. -
          CREHANA no es responsable de los posibles daños o perjuicios en la
          Plataforma, que puedan derivar de interferencias, omisiones,
          interrupciones, virus informáticos, averías o desconexiones en el
          funcionamiento operativo del sistema electrónico, motivado por causas
          ajenas a CREHANA de retrasos o bloqueos en el uso del sistema causados
          por deficiencias o sobrecargas en Internet o en otros sistemas
          electrónicos, así como también de daños que puedan ser causados por
          terceras personas mediante intromisiones ilegítimas fuera del control
          de CREHANA.
        </li>
        <li>
          <strong>Respecto de los Servicios</strong>. - CREHANA, sus empleados o
          directivos no son responsables de los daños o perjuicios indirectos,
          accidentales o por eventos de caso fortuito, incluyendo daños por
          lucro cesante, pérdida de uso y pérdida de datos derivados de o en
          relación con los Cursos, los Proyectos y/o los presentes términos.
        </li>
      </ol>
    </section>
    <section>
      <Subtitle>24. Disponibilidad y Suspensión del Servicio</Subtitle>
      <p>
        En el supuesto de que algunas de las Membresías que ofrece CREHANA,
        dejen de estar disponible para el público en general, se respetarán las
        condiciones de los Usuarios que ya adquirieron dicha Membresía en su
        momento hasta el término de plazo de la misma.
      </p>
      <p>
        En caso de incumplimiento de cualquiera de las disposiciones contenidas
        en los presentes Términos y Condiciones, CREHANA podrá suspender la
        Cuenta, suspender el Servicio y/o retirarle o denegarle el acceso a la
        Plataforma o al Sitio Web, en cualquier momento y sin necesidad de
        notificación previa de ningún tipo, así como, de ser el caso, presentar
        las denuncias ante las autoridades competentes. Se considerará
        infracción a los presentes Términos y Condiciones, la comisión o
        participación en actos que constituyan conductas abusivas, inapropiadas
        o ilícitas, actividades fraudulentas o ilegales y en general el comercio
        de cualquier objeto ilícito o producto de un delito.
      </p>
    </section>
    <section>
      <Subtitle>
        25. Cambios en las Condiciones y Cesión de Posición contractual
      </Subtitle>
      <p>
        CREHANA se reserva el derecho de actualizar, modificar o reemplazar
        cualquier parte de estas Condiciones, sin necesidad de previo aviso.
        Todos los Términos y Condiciones Generales modificados entrarán en vigor
        al momento de su publicación para todos los efectos legales a que haya
        lugar.
      </p>
      <p>
        Es la responsabilidad del Usuario revisarlo de manera periódica para
        poder identificar cambios. Su navegación en la Plataforma supondrá la
        aceptación de cualquier modificación realizado en las Condiciones.
        Además, CREHANA podría incluir nuevos Servicios o funciones en el
        futuro. De ser el caso, tales Servicios se verán sujetos a los
        Condiciones especificados en este documento. En caso de no estar de
        acuerdo con las modificaciones que se pudiesen dar, el Usuario podrá
        cancelar su suscripción y/o presentar sus reclamos, dudas y/o consultas
        al siguiente correo electrónico <Link href="hola@crehana.com" />.
      </p>
      <p>
        Asimismo, CREHANA podrá ceder o transferir los derechos y obligaciones
        como su posición contractual derivados del presente documento y/o de la
        Plataforma, en cualquier momento. Por lo que, el Usuario autoriza
        expresamente la cesión del presente documento, así como la Política de
        Privacidad en favor de cualquier persona que (i) quede obligada por el
        presente; y/o (ii) que sea el nuevo responsable de los derechos y/o
        obligaciones que surjan del presente documento y/o de la Plataforma.
        Luego de producida la cesión, CREHANA no tendrá ninguna responsabilidad
        con respecto de cualquier hecho que ocurra, a partir de la fecha de la
        cesión.
      </p>
    </section>
    <section>
      <Subtitle>26. Indemnización</Subtitle>
      <p>
        El Usuario mantendrá indemne a CREHANA, sus filiales, empresas
        controladas y/o controlantes, directivos, administradores,
        representantes y empleados, respecto de cualquier reclamo o demanda de
        otros Usuarios o terceros por las actividades que el Usuario pueda
        realizar en la Plataforma, y/o por cualquier incumplimiento a las
        Condiciones y demás Políticas que se entienden incorporadas al presente
        o por la violación de cualquier ley o derechos de terceros.
      </p>
    </section>
    <section>
      <Subtitle>27. Créditos Crehana</Subtitle>
      <ul>
        <li>
          <strong>Uso de créditos</strong>
          <br />
          <span>
            Recuerda que si tienes créditos, puedes usarlo para comprar Packs de
            Cursos y/o PAYG. No olvides que cobraremos el total de tus créditos
            en cada transacción; es decir, si por ejemplo el total de tu compra
            es 10 usd y tienes 20 créditos, al finalizar tu compra ya no tendrás
            créditos. En caso de que el valor de tu compra exceda a tus
            créditos, te cobraremos el saldo correspondiente en tu moneda local.
          </span>
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>28. Jurisdicción y legislación aplicable</Subtitle>
      <p>
        Todas las controversias que deriven de la interpretación o el
        cumplimiento de los presentes Términos y Condiciones Generales o que
        guarden relación con éstos, incluyendo cualquier reclamo que pudiera una
        de las Partes tener en contra de la otra derivada de, o relacionado con
        el uso de la Plataforma se regirá por las leyes peruanas, renunciando en
        este acto las Partes a cualquier otra legislación o jurisdicción que,
        por motivo de sus domicilios presentes o futuros, pudiere
        corresponderles y se someten a los Juzgados y Tribunales del Distrito
        Judicial de Lima.
      </p>
      <p>
        Para sugerencias y/o comentarios sobre los Términos y Condiciones
        Generales de nuestra Plataforma pueden enviarnos una comunicación al
        siguiente correo electrónico <Link href="hola@crehana.com" />.
      </p>
      <p>
        <strong>
          Recuerda que al realizar tu compra, la tarjeta que utilices se quedará
          guardada como método de pago predeterminado. Sin embargo, puedes
          eliminar esta información cuando desees, ingresando en la
          configuración de tu cuenta.
        </strong>
      </p>
      <p>
        Declaro que luego de haber leído los Términos y Condiciones Generales,
        acepto todo lo anteriormente mencionado. En señal de conformidad,
        procedo a llenar el formulario de compra de usuario visitante.
      </p>
    </section>
    <section>
      <Subtitle>29. Trial Premium 7 días</Subtitle>
      <ul>
        <li>
          Válido para nuevos usuarios usando el código brindado por el
          influencer.
        </li>
        <li>
          Una vez canjeado el cupón, se activan los 7 días de prueba para la
          experiencia Premium en la misma cuenta del cupón canjeado.
        </li>
        <li>
          A los 7 días de canjeado el cupón, se quita el acceso a la prueba de
          Crehana Premium en la cuenta del usuario y los cursos quedarán
          bloqueados hasta tener una nueva membresía activa y/o adquirir el
          curso.
        </li>
        <li>
          La prueba de membresía Premium puede ser usada una sola vez por
          usuario.
        </li>
        <li>El cupón es personal e intransferible.</li>
        <li>
          El usuario brinda de manera voluntaria sus datos para que podamos
          ponernos en contacto con él/ella.
        </li>
        <li>
          No se podrán pausar los días, ni cambiar de fecha, una vez canjeado
          corren los 7 días.
        </li>
        <li>
          No se podrá trasladar a otra cuenta, siendo única cuenta la que se
          registró el usuario.
        </li>
        <li>No se tiene acceso a corrección de proyectos.</li>
        <li>No se tiene acceso a mentorías.</li>
        <li>No se obtendrá diploma de aprobación.</li>
        <li>
          Para obtener la constanccia de participación, se debe subir el
          proyecto.
        </li>
        <li>
          Luego de subir los proyectos, se obtendrá una constancia de
          participación.
        </li>
        <li>
          Crehana Premium no da acceso a Microdegrees ni a especializaciones.
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>
        30. Cupones de descuento en ${CREHANA_BASE_URL_PRD}/cupones
      </Subtitle>
      <ul>
        <li>
          Los cupones solo son válidos si se ingresa a través de las URL
          indicadas en ${CREHANA_BASE_URL_PRD}/cupones
        </li>
        <li>
          Los cupones no tienen fecha de caducidad pero solo pueden ser
          utilizados 1 vez
        </li>
        <li>El cupón es personal e intransferible.</li>
        <li>
          Los cupones Crehana no son válidos para packs, membresías o cursos en
          promoción, debido a que ya cuentan con un precio de descuento
          aplicado.
        </li>
        <li>
          El usuario brinda de manera voluntaria sus datos para que podamos
          ponernos en contacto con él/ella.
        </li>
        <li>
          No se podrá trasladar a otra cuenta, siendo única cuenta con la que se
          registró el usuario.
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>31. Prueba de Premium 24 horas para usuarios nuevos</Subtitle>
      <ul>
        <li>
          Válido para usuarios nuevos que se registren en {CREHANA_HOSTNAME_PRD}
        </li>
        <li>
          Una vez activada la prueba de la membresía Premium Individual, el
          usuario contará con acceso a todos los cursos con fecha de publicación
          no menor a 30 días.
        </li>
        <li>
          Al finalizar la prueba de 24 horas, se quitará el acceso a Crehana
          Premium en la cuenta del usuario y los cursos quedarán bloqueados
          hasta tener una membresía activa y/o adquirir el curso.
        </li>
        <li>
          La prueba de membresía Premium Individual puede ser usada una sola vez
          por usuario.
        </li>
        <li>
          El usuario brinda de manera voluntaria sus datos para que podamos
          ponernos en contacto con él/ella.
        </li>
        <li>
          No se podrán pausar los días, ni cambiar de fecha, una vez registrado
          corren las 24 horas.
        </li>
        <li>
          No se podrá trasladar a otra cuenta, siendo única cuenta la que se
          registró el usuario.
        </li>
        <li>No se tiene acceso a corrección de proyectos.</li>
        <li>No se tiene acceso a mentorías.</li>
        <li>No se obtendrá diploma de aprobación.</li>
        <li>
          Se tendrá acceso a una constancia de participación luego de subir los
          proyectos.
        </li>
        <li>
          La prueba de Crehana Premium por 24 horas no da acceso a MicroDegrees
          ni a especializaciones.
        </li>
      </ul>
    </section>
    <section id="promocion-refiere-a-un-amigo-a-premium">
      <Subtitle>32. Promoción Refiere a un amigo a Premium</Subtitle>
      <ul>
        <li>
          El usuario Premium podrá enviar invitaciones para unirse a la
          membresía Premium Individual, Dúo y Familiar a las personas que desee.
        </li>
        <li>
          Las invitaciones se realizarán únicamente desde las cuentas de los
          administradores de las membresías premium.
        </li>
        <li>
          Las invitaciones se enviarán a través de {CREHANA_HOSTNAME_PRD}
          /referidos.
        </li>
        <li>
          Para ganar los 6 meses adicionales en la cuenta del usuario, las
          personas invitadas deberán comprar la membresía Premium Individual,
          Dúo ó Familiar a través de la invitación que reciba por correo
          electrónico.
        </li>
        <li>
          El usuario ganará 6 meses adicionales por cada invitado que compre una
          membresía Premium.
        </li>
        <li>
          Los invitados también ganarán 6 meses adicionales en sus cuentas (solo
          1 vez por cada usuario).
        </li>
        <li>Los 6 meses se adicionarán al término de la membresía en curso</li>
        <li>
          Válido para membresías Premium Individual, Dúo y Familiar activas.
        </li>
        <li>
          El usuario y sus invitados brindan de manera voluntaria sus datos para
          que podamos ponernos en contacto con él/ella.
        </li>
        <li>
          El beneficio no se podrá trasladar a otra cuenta, siendo única cuenta
          la que se registró el usuario.
        </li>
        <li>
          Crehana Premium no da acceso a Microdegrees ni a especializaciones.
        </li>
        <li>
          Solo se podrá referir a personas que no cuenten con una cuenta en
          Crehana.
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>33. Aviso sobre los proyectos de estudiantes:</Subtitle>
      <p>
        Si un estudiante incurre en plagio en tres (3) proyectos o más, y es
        previamente notificado por CREHANA para rectificarlo y no lo hace,
        CREHANA podrá desactivar su cuenta de inmediato, sin que exista lugar a
        reembolso alguno.
      </p>
      <section>
        <strong>1. Reglas básicas estudiantes</strong>
        <ul>
          <li>
            Lenguaje no regresivo: El uso de calificativos, lenguaje vulgar o
            soez debe ser rotundamente evitado en nuestra comunicación. Recuerda
            que no necesitamos usar palabras ofensivas para mostrar nuestra
            posición.
          </li>
          <li>
            Respeto y tolerancia: Es muy importante que exista respeto entre
            todos, recuerda este es un espacio para compartir. Sabemos que
            podemos tener opiniones diferentes, pero es importante respetarlas.
            Si uno o más usuarios comienzan una discusión donde se falte el
            respeto, el o la moderador(a) tendrá la potestad de ocultar sus
            comentarios o bloquear a estos usuarios del chat.
          </li>
          <li>
            No discriminación: La diversidad y diferencias en cada uno de
            nosotros son súper valiosas en nuestra comunidad.
          </li>
          <li>No acosar, amenazar, suplantar o intimidar a otros usuarios.</li>
          <li>
            Prohibido publicar cualquier mensaje con la intención de conseguir
            alguna contraseña, cuenta o información privada de cualquiera de los
            usuarios de Crehana.
          </li>
          <li>No publicar contenido que sea considerado como spam.</li>
          <li>
            Los usuarios reconocen que las marcas, software y otros signos
            distintivos son propiedad de Crehana.
          </li>
          <li>
            Los usuarios reconocen que el contenido del portal es exclusiva
            propiedad de Crehana, por lo cual es ilegal descargarlos,
            transferirlos, comercializarlos, y realizar cualquier acto que no
            sea considerado como uso normal de un usuario. No podrá hacerse
            ningún acto de disposición de los cursos, contenidos o materiales
            que se encuentren en el portal, fuera de su calidad y alcance como
            estudiantes. Si ocurriera un caso mencionado precedentemente,
            Crehana podrá iniciar acciones legales que considere pertinentes
          </li>
          <li>
            Crehana tendrá la facultad de eliminar cualquier respuesta, opinión
            o declaración que considere que no siguen las reglas básicas de
            estudiantes.
          </li>
          <li>
            La adquisición de uno o más cursos y/o membresías no implica la
            transferencia de software a los estudiantes.
          </li>
          <li>
            No utilizar información de profesores, usuarios o terceros que
            vulneren la legislación de datos personales.
          </li>
        </ul>
      </section>
      <section>
        <strong>2. Reglas básicas aplicables a proyectos</strong>
        <ul>
          <li>No utilizar contenido de índole sexual.</li>
          <li>
            La misoginia, el sexismo, el apelar a frases y/o material gráfico
            que degraden o cosifiquen a las personas son situaciones que no
            pueden ser parte del proyecto final de tus cursos en Crehana.
          </li>
          <li>
            No publicar cualquier tipo de contenido difamatorio, obsceno,
            pornográfico, ofensivo, que infrinja los derechos de cualquier
            usuario, profesor o tercero. Crehana tendrá la facultad de eliminar
            cualquier proyecto que considere que no sigue las reglas básicas
            aplicables a éstos.
          </li>
          <li>
            No publicar obras o proyectos que infrinjan cualquier derecho de
            autor de cualquier persona.
          </li>
          <li>
            El incumplimiento a alguna de estas reglas, otorga a Crehana la
            facultad de contactar al estudiante -a través de sus mentores y/o
            staff- para que este último se desista y sustituya el proyecto por
            uno acorde a las reglas. En ningún caso, Crehana está obligada a
            otorgar certificado a favor de estudiantes que infrinjan estas
            reglas.
          </li>
          <li>
            Recuerda que las calificaciones y otorgamiento de certificados están
            a cargo de los mentores y el staff de Crehana, mas no del profesor.
          </li>
          <li>
            Finalmente, no olvides revisar los lineamientos de proyectos
            finales.
          </li>
        </ul>
      </section>
    </section>
    <section>
      <Subtitle>34. Cursos desactivados</Subtitle>
      <p>
        Cursos desactivados y/o dados de baja: Crehana está constantemente
        actualizando sus contenidos, por lo que periódicamente algunos cursos
        dejan de ser parte del catálogo. No obstante ello, para aquellos
        estudiantes que ya hayan descargado el contenido de estos cursos,
        <strong>
          {' '}
          podrán seguir visualizándolos en su panel de estudios.{' '}
        </strong>
        El único servicio que no estará disponible será el de mentoría y
        acompañamiento, pero brindaremos constancias de participación a todos
        los estudiantes que completen el curso y presenten su proyecto final.
      </p>
      <p>
        Actualización de cursos: Como parte de la actualización permanente de
        los cursos, estaremos anunciando las fechas en que éstas serán
        realizadas, con un{' '}
        <strong>preaviso de al menos 7 días calendario. </strong>
        En este preaviso,{' '}
        <strong>
          Crehana incluirá los siguientes pasos para que los estudiantes ya
          inscritos en el curso que se va a actualizar puedan realizar
          nuevamente su inscripción sin costos adicionales.
        </strong>
      </p>
      <p>
        Durante el proceso de actualización de estos cursos, los servicios de
        mentoría se verán suspendidos hasta que el mismo finalice. Si sigues
        teniendo dudas y/o inconvenientes sobre algún tema relacionado a cursos
        actualizados y/o desactivados, escríbenos a{' '}
        <Link href="hola@crehana.com" />.
      </p>
    </section>
    <section>
      <Subtitle>
        35. Sobre impuestos propios de cada país por compras en Crehana:
      </Subtitle>
      <p>
        Los precios base que se muestran en la Plataforma son en dólares
        americanos, el monto que ves en tu moneda local es un aproximado que
        puede variar de acuerdo a tu banco y el tipo de cambio del día. Crehana
        es una empresa constituida en Estados Unidos de América, por lo que es
        posible que se apliquen impuestos propios según país por compras en
        plataformas extranjeras y que deberán ser asumidos por los usuarios
        finales (Argentina, Ecuador, Chile, Colombia, Perú y otros países en los
        que se implementen a futuro según Ley).
      </p>
    </section>
    <section>
      <Subtitle>36. Sobre conductas fraudulentas en la plataforma</Subtitle>
      <p>Los usuarios de Crehana no podrán:</p>
      <ol>
        <li>
          Iniciar reclamos en nombre, representación y/o por cuenta de terceros
          -salvo que tengan un poder formal escrito para hacerlo-;
        </li>
        <li>
          Iniciar reclamos basados en hechos o situaciones falsas y/o
          fraudulentas; y,
        </li>
        <li>
          Incurrir, a criterio de Crehana, en conductas o actos dolosos o
          fraudulentos para obtener la cobertura del programa. Recuerda que
          tenemos TyC aplicables, las cuales puedes revisar en este link{` `}
          <Link
            href={`${CREHANA_BASE_URL_PRD}/legal/terminos-y-condiciones/`}
          />
        </li>
      </ol>
      <p>
        Crehana está en constante monitoreo de situaciones como las mencionadas
        y todo usuario que incurra en estas acciones, será sancionado con la
        cancelación de su cuenta en Crehana, perdiendo totalmente acceso al
        contenido que haya sido adquirido de manera fraudulenta. En dicho caso,
        de verificarse la infracción, no corresponderá devolución parcial ni
        total.
      </p>
      <p>
        <strong>Requerimientos por “Autoridades públicas”:</strong> Crehana
        podrá colaborar brindando información de los usuarios cuando las
        autoridades administrativas y judiciales que en ejercicio de su
        competencia requieran dicha información de forma preventiva; es decir,
        aunque no exista una orden ni una citación ejecutiva o judicial al
        efecto, con la finalidades de: (a) colaborar en la investigación y
        denunciar fraudes, piratería, violaciones de propiedad intelectual o
        industrial o cualquier otro ilícito, así como cualquier actividad o
        circunstancia que pudiera generarle responsabilidad legal a Crehana y/o
        a sus usuarios; (b) salvaguardar de un interés público, la procuración o
        administración de justicia, el reconocimiento, ejercicio o defensa de un
        derecho en un proceso judicial o administrativo, y/o la resolución de
        controversias; y (c) dar cumplimiento a alguna ley, reglamento o
        disposición legal aplicable, o a algún mandato de autoridad competente
        debidamente fundado y motivado.
      </p>
      <p>
        En estos casos, se notificará a los usuarios que se está procediendo con
        el envío de la información a las autoridades públicas.
      </p>
    </section>
    <section>
      <Subtitle>37. Campaña Back to School HP</Subtitle>
      <HPBackToSchoolCampaign />
    </section>
    <section>
      <Subtitle>38. Trial Premium 3 días</Subtitle>
      <p>
        1. Dirigido a usuarios que compran un curso o un pack de cursos de la
        plataforma.
      </p>
      <p>
        2. Dirigido a usuarios que tengan una tarjeta asociada a la plataforma.
      </p>
      <p>
        3. El anuncio del trial se muestra en el reproductor de clases cuando el
        alumno tenga más del 20% de progreso en un curso.
      </p>
      <p>
        4. Se proporcionará la membresía principal (con marco dorado) que se
        esté promocionando en el momento en el landing de membresías premium:
        <Link href="https://creha.co/3xSeNlT" />
      </p>
      <p>
        5. El trial premium tiene como duración 3 días. Después de este plazo de
        tiempo se crea una nueva membresía, se realiza el pago automático y se
        le asigna el tiempo según la membresía elegida (actualmente 12 meses).
      </p>
      <p>
        6. Si tu trial premium de membresía se autorenovó y no cancelaste tu
        suscripción, no es posible obtener una devolución de dinero. Toda la
        información es comunicada y aceptada al momento de la suscripción y en
        el mail de bienvenida a la prueba.
      </p>
      <p>
        <strong>
          Declaro que luego de haber leído los Términos y Condiciones Generales,
          acepto todo lo anteriormente mencionado. En señal de conformidad,
          procedo a llenar el formulario de compra de usuario visitante.
        </strong>
      </p>
    </section>
    <section>
      <Subtitle>39.MicroDegrees y Bootcamps</Subtitle>
      <p>
        CREHANA ofrece la posibilidad de certificarse en distintas materias y
        áreas con programas 100% digitales y de corta duración.
      </p>
      <p>
        CREHANA, ofrece MicroDegrees, Programas digitales de cursos de corta
        duración, producidos por plataformas de educación en línea (e-learning)
        en colaboración con destacadas universidades o instituciones, cuyo
        propósito es enseñar una materia específica. Estos programas exigen la
        presentación de un proyecto parcial por curso, que forma parte de un
        proyecto final que tendrá que aprobar para certificarse. Para obtener
        mayor detalle sobre nuestro Programa puede ingresar a la siguiente URL:
        <Link href="https://bit.ly/3e42Hgh" />.
      </p>
      <p>
        Por otro lado, los Bootcamps Crehana son programas de entrenamiento
        intensivo de un mes, donde a través de una metodología basada en
        aprender haciendo (learning by doing), los estudiantes desarrollarán
        habilidades que puedan poner en práctica rápidamente en sus
        emprendimientos o donde trabajan a partir de la resolución de un desafío
        semana a semana. Al concluir el Programa con éxito, recibirá un
        certificado a nombre de Crehana por tu participación en el Bootcamp. Si
        desea mayor información sobre el Programa, podrás revisarlo ingresando a
        la siguiente dirección URL: <Link href="https://bit.ly/3E61vUm" />.
      </p>
    </section>
    <section>
      <Subtitle>40. Full Pass</Subtitle>
      <ul>
        <li>
          Fechas: desde viernes 21 a las 12.00 a.m. hasta el sábado 22 de enero
          del 2022 a las 11.59 p.m. (zona horaria GTM-5).{' '}
        </li>
        <li>
          Todo el catálogo de cursos de Crehana estará disponible gratis por 48
          horas desde el momento en el que el usuario se inscribe al Full Pass,
          a excepción de Se Regalan Dudas quienes no participarán de la
          dinámica.
        </li>
        <li>
          Durante la vigencia de Full Pass ni los usuarios nuevos ni los
          usuarios que estén inscritos a la dinámica, podrán comprar cursos del
          catálogo desde la página web (
          <Link href={`${CREHANA_BASE_URL_PRD}/`} />
          ); sin embargo, sí podrán hacerlo desde la App instalada en su
          dispositivo móvil. Una vez finalizada la dinámica el sábado 22 de
          enero a las 23:59 p.m. (GTM-5) podrán comprar con normalidad desde la
          web.
        </li>
        <li>
          Sí se podrán comprar membresías{' '}
          <Link href={`${CREHANA_BASE_URL_PRD}/premium/`} />
        </li>
        <li>
          Solo se emitirá automáticamente una constancia de participación luego
          de completar realizar el proyecto final de cada curso sin pasar por
          mentoría; es decir, no reciben feedback de mentores.
        </li>
        <li>
          El certificado de participación emitido se podrá compartir en redes.
        </li>
        <li>
          Para poder empezar con el primer curso, es obligatorio que el usuario
          comparta la dinámica en redes (viral loop).
        </li>
      </ul>
    </section>
    <section>
      <Subtitle>41. Gamificación vigentes sólo para clientes activos</Subtitle>
      <p>
        Es un programa (en adelante, el “Programa”) de gamificación y beneficios
        exclusivamente dirigido a estudiantes de Crehana for Business que
        cuenten con nuestro plan Elevate, con el objetivo de incentivar y
        premiar el uso de las actividades de aprendizaje realizadas durante el
        uso de la plataforma. Por eso, como Cliente, conozco y acepto que mi
        participación en el Programa implica aceptar expresamente todas las
        condiciones establecidas en estos términos y condiciones (en adelante,
        los “Términos y Condiciones”)
      </p>
      <p>1. ¿Quiénes pueden participar?</p>
      <ol>
        <li>
          Todas las personas físicas que tengan una cuenta Crehana for Business,
          que cuenten con la funcionalidad activa y acepten estos Términos y
          Condiciones.
        </li>
      </ol>

      <p>2. ¿En qué consiste el Programa?</p>
      <ol>
        <li>
          El Programa consiste en acumular Puntos que serán nombrados acorde a
          su empresa (en adelante, “Puntos”) a través del cumplimiento de
          eventos o “misiones”, para canjear beneficios exclusivos que el
          administrador de su empresa ofrezca dentro catálogo de recompensas
        </li>
      </ol>
      <p>3. Puntos</p>
      <p>3.1. ¿Cómo puedo sumar Puntos?</p>
      <ol>
        <li>
          Para sumar Puntos tendrá que cumplir con las actividades de
          aprendizaje Desafíos disponibles en LMS Crehana. Las condiciones de
          cada actividad estarán allí detalladas en la sección “logros”
        </li>
        <li>
          Todos los logros (hitos de aprendizaje) o actividades recurrentes
          (actividades realizadas más de una vez) acumularán puntos
        </li>
        <li>
          Los puntos ganados tienen una vigencia de 12 meses calendario, o lo
          que se disponga en su administrador específicamente con relación a la
          activación de su cuenta.
        </li>
        <li>No se computarán fracciones de Puntos.</li>
      </ol>
      <p>3.2. ¿Dónde puedo consultarlos?</p>
      <ol>
        <li>
          Podré consultar la cantidad de Puntos acumulados en la barra de
          navegación principal (esquina superior derecha) y mi historial de
          movimientos en la sección (Recompensas `{'>'}` Historial).
        </li>
        <li>
          Asimismo, Crehana le informará a través de resúmenes semanales los
          Puntos acumulados durante su aprendizaje y mientras se mantenga activo
          en la plataforma.
        </li>
        <li>
          Los Puntos se acreditarán en su cuenta del Programa en un máximo de 30
          días hábiles de haber cumplido el evento.
        </li>
      </ol>
      <p>3.3. ¿Qué puedo hacer con los Puntos?</p>
      <ol>
        <li>
          Al estar adherido al Programa podré canjear los Puntos acumulados
          dentro del Marketplace por distintos productos y/o servicios, siempre
          que haya acumulado la cantidad de Puntos necesarios para la obtención
          de los mismos.
        </li>
        <li>
          Los Puntos acumulados en el Programa no tienen valor monetario alguno
          y no podrán ser canjeados por dinero a menos que le hayan configurado
          esta opción.
        </li>
        <li>
          LMS Crehana no se responsabiliza por la entrega de premios o aquellos
          premios que por motivos logísticos no fueron entregados. La
          responsabilidad de realizar la entrega del premio es de su empresa.
          Cualquier reclamo o inconformidad deberá tratarlo directamente con el
          administrador de su empresa.
        </li>
      </ol>
      <p>3.4. ¿Cuánto duran los Puntos?</p>
      <ol>
        <li>
          Vigencia: Los Puntos acumulados en el Programa no constituyen mi
          propiedad y tendrán una vigencia de 12 meses corridos desde la fecha
          de acreditación en mi Cuenta. Transcurrido dicho plazo, si los Puntos
          no se canjearon, vencerán, previa notificación con 30 (treinta) días
          de anticipación a la fecha de vencimiento
        </li>
        <li>Caducidad: Los Puntos caducan en los siguientes supuestos:</li>
        <ul>
          <dd>i. con la finalización del Programa.</dd>
          <dd>
            ii. en caso de que registre 6 (seis) meses de inactividad con el
            Programa.
          </dd>
          <dd>
            iii. en caso de que voluntariamente cancele la participación en el
            Programa o deje de ser Cliente.
          </dd>
        </ul>
      </ol>
      <p>
        3.5. Intransferibles: Los Puntos son personales e intransferibles a
        ninguna otra persona o entidad ni bajo ningún título o causa (vgr.
        Fallecimiento, incapacidad, disolución de la sociedad conyugal, etc.) y
        tampoco podrán ser transferidos a ninguna otra cuenta del Programa.
      </p>
      <p>4. Premios</p>
      <p>
        4.1. La gestión de entrega de los Premios será responsabilidad del
        administrador de la cuenta de Empresa, por lo que LMS Crehana no se
        responsabiliza por la entrega de premios o aquellos premios que por
        motivos logísticos no fueron entregados.
      </p>
      <p>
        4.2. En caso de no ser posible la entrega de los Premios solicitados por
        causas ajenas a la voluntad de la Empresa,esta podrá negociar con sus
        colaboradores a fin de llegar a un acuerdo en conjunto y reemplazar los
        Premios por otros de igual o similar valor y/o características.{' '}
      </p>
      <p>5. Condiciones generales</p>
      <p>
        5.1. Los Términos y Condiciones para la participación en el Programa son
        complemento y parte integrante de las cláusulas y condiciones
        particulares descritas en las solicitudes y/o contratos de los productos
        y/o servicios de Crehana, que se incorporen al Programa, las que
        mantendrán plena vigencia
      </p>
      <p>
        5.2. Crehana se reserva el derecho de desvincularme del Programa si en
        algún momento registrase incumplimientos o mal uso de Playroom, con
        alguna de las condiciones de los presentes Términos y Condiciones o
        bien, ante cualquier fraude o abuso relacionado con la acumulación de
        Puntos o utilización de Programa que se atribuya. En esos casos, perderá
        los Puntos acumulados hasta esa fecha.
      </p>
      <p>
        5.3. Crehana se reserva el derecho de dejar sin efecto el Programa o de
        modificar total o parcialmente los Términos y Condiciones del mismo en
        cualquier momento.
      </p>
      <p>
        5.4. Todas las preguntas o asuntos concernientes al Programa serán
        resueltos por Crehana, a excepción de la gestión de entrega de los
        premios. Todo lo relacionado a la entrega de premios, deberá coordinarse
        directamente entre la empresa y el colaborador.
      </p>
      <p>
        5.5. Crehana no se hace responsable del uso de los Puntos ni por los
        servicios recibidos de cualquiera de las empresas participantes con
        relación al Programa.
      </p>
    </section>
    <section>
      <Subtitle>42. Términos y condiciones sobre la utilización de AI</Subtitle>
      <p>
        <strong>a. Sobre la tecnología utilizada</strong>
      </p>
      <p>
        1. La tecnología que soporta nuestra propuesta está realizada por
        OpenAI, es decir, no hemos desarrollado una propuesta ad hoc de Crehana,
        no obstante nos apoyamos en modelos de software libre para poder
        integrarlo y manejarlo con nuestra plataforma. Los modelos que
        utilizaremos son Whisper y ChatGPT 3.5 turbo. Los cuales tienen sus
        propios términos y condiciones, sin embargo, los servicios ofrecidos se
        encuentran sujetos a nuestros propios términos.
      </p>
      <p>
        2. OpenAI es una tecnología de inteligencia artificial que utiliza
        algoritmos de aprendizaje automático para generar respuestas a partir de
        la información proporcionada por el usuario.
      </p>
      <p>
        3. La calidad de las respuestas generadas por el OpenAI puede variar
        según la precisión de los datos proporcionados por el usuario y el
        modelo de inteligencia artificial utilizado.
      </p>
      <p>
        4. Es importante tener en cuenta que OpenAI no es una fuente infalible
        de información y que siempre es recomendable verificar cualquier
        información importante con fuentes adicionales
      </p>

      <p>
        <strong>b. Sobre nuestra versión Beta</strong>
      </p>
      <p>
        5. La versión actual pertenece a un {`"beta"`}, que se refiere a una
        versión de la aplicación que aún está en desarrollo y que se está
        probando antes de su lanzamiento oficial. Esta versión beta se suele
        lanzar a un grupo limitado de usuarios (como un grupo de pruebas) para
        que puedan probar la aplicación y proporcionar comentarios y sugerencias
        sobre su funcionamiento y cualquier problema que puedan encontrar. Para
        dejar feedback sobre los features relacionados a esta tecnología podrá
        hacerlo en el{' '}
        <strong>
          siguiente enlace:{' '}
          <a
            href="https://form.typeform.com/to/hztHLFzz"
            className="link-light link-level4 font-body3"
          >
            https://form.typeform.com/to/hztHLFzz
          </a>
        </strong>
      </p>
      <p>
        6. Al utilizar nuestra aplicación, acepta que su contenido sea procesado
        por el algoritmo de inteligencia artificial para la generación de
        transcripciones, apuntes y preguntas de evaluaciones.
      </p>
      <p>
        7. Por ahora, podrán utilizar el servicio de forma gratuita aquellas
        empresas “Beta Testers” que deseen probar la funcionalidad para poder
        analizar el contexto de uso y posibles ajustes de facturación. Es decir,
        la funcionalidad por ahora se cuenta liberada de cobro, solo deberían
        tener una cuenta vigente en elevate; sin embargo, puede haber ajustes
        posteriores, que se informará a su cuenta y/o en nuestro sitio web. Los
        aumentos de precios entrarán en vigencia 14 días después de que se
        publique la funcionalidad al público general, excepto algún acuerdo
        previo realizado por razones contractuales.
      </p>
      <p>
        8. Estamos trabajando constantemente para mejorar nuestros servicios y
        hacerlos más exactos, confiables, seguros y beneficiosos para ti. Sin
        embargo, debido a que el aprendizaje automático utiliza probabilidades,
        es posible que en algunas ocasiones los resultados de nuestros servicios
        no sean completamente precisos y no reflejen perfectamente a personas,
        lugares u otros detalles de la realidad. Cada usuario debe evaluar la
        precisión de cualquier sugerencia según corresponda para su caso de uso,
        incluso mediante la <strong>revisión humana</strong> de la sugerencia.
      </p>

      <p>
        <strong>c. Sobre requisitos y consideraciones</strong>
      </p>
      <p>
        9. No recopilamos ni almacenamos ningún dato personal durante este
        proceso, lo que garantiza la seguridad y privacidad de su información
        personal.
      </p>
      <p>
        10. Además, tomamos medidas para garantizar la seguridad de su
        información compartida, no podemos hacernos responsables por la
        filtración de información.
      </p>
      <p>
        11. Cada usuario es responsable de la información que comparte en
        nuestro sitio y debe garantizar que cumple con todas las leyes,
        regulaciones aplicables y que no infrinja estos términos y condiciones.
      </p>
      <p>
        12. Nos reservamos el derecho de modificar estos términos y condiciones
        en cualquier momento, lo cual haremos previo aviso en un lapso de 24
        horas.
      </p>
      <p>
        13. Asimismo, Crehana puede rescindir estos términos inmediatamente
        después de notificarle, si hay cambios en las relaciones con proveedores
        de tecnología de terceros fuera de nuestro control, relacionado a la
        baja de la funcionalidad o para cumplir con la ley / las solicitudes del
        gobierno, lo cual será notificado con al menos 30 días de anticipación.
      </p>
      <p>
        14. Estos Términos entran en vigencia cuando utiliza los Servicios por
        primera vez y permanecerán vigentes hasta que finalice el producto
        “Beta”. Cada usuario puede rescindir estos Términos en cualquier momento
        y por cualquier motivo al interrumpir el uso de los Servicios y el
        Contenido.
      </p>
    </section>
  </RouteWrapper>
);

export default TermsAndConditions;
